import React, { useEffect, useState } from 'react';
import { FormLabel } from 'react-bootstrap';
import YesNoToggle from 'components/inputs/YesNoToggle';
import { useDispatch, useSelector } from 'react-redux';
import { changeStep, updateForm } from 'actions/formActions';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import FormikTextInput from 'components/inputs/FormikInputs';

const defaultValues = {
  chargerArrivalDate: '',
  ACDBArrivalDate: '',
  nameOfTransporter: '',
  consigneeName: '',
  consigneeContact: '',
  missingItems: '',
};

const TransportDetails = ({ currentStep }) => {
  const [checked, setChecked] = useState('no');
  const [initialValues, setInitialValues] = useState(defaultValues);
  const { form } = useSelector((state) => state.forms);
  const role = useSelector((s) => s.auth?.user?.user?.role ?? s.auth?.user?.role ?? null); // NEW
  const dispatch = useDispatch();

  useEffect(() => {
    if (form !== null) {
      setInitialValues({
        chargerArrivalDate: form?.chargerArrivalDate || new Date().toISOString().slice(0, 10),
        ACDBArrivalDate: form?.ACDBArrivalDate || new Date().toISOString().slice(0, 10),
        nameOfTransporter: form?.nameOfTransporter || '',
        consigneeName: form?.consigneeName || '',
        consigneeContact: form?.consigneeContact || '',
        missingItems: form?.missingItems || '',
      });
      if (form?.anyDamage) {
        setChecked(form?.anyDamage);
      }
    }
  }, [JSON.stringify(form)]);

  const canSave = role === 'admin' || (form?.status !== 'approved' && form?.status !== 'pending'); // NEW

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      values.step = (currentStep + 1).toString();        // NEW (ensure step is set whenever saving)
      values.anyDamage = checked;                         // NEW (persist radio value)

      if (form?.id && canSave) {                          // CHANGED
        dispatch(updateForm(form.id, values));            // CHANGED
      } else if (form?.id && !canSave) {                  // NEW
        // Non-admin on approved/pending: don't save, just advance
        dispatch(changeStep(currentStep + 1));            // NEW
        return;
      } else {
        // No form id available yet
        dispatch(changeStep(0));
        return;
      }
    },
  });

  const handleChange = (e) => {
    setChecked(e.target.value);
  };

  return (
    <div className="card-body">
      <form onSubmit={formik.handleSubmit}>
        <div className="row my-3">
          <div className="col-6">
            <div className="mb-3">
              <FormikTextInput
                type="date"
                className="text-input"
                label="Charger Arrival Date at Site"
                isRequired
                name="chargerArrivalDate"
                formik={formik}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="mb-3">
              <FormikTextInput
                type="date"
                className="text-input"
                label="ACDB Arrival Date at Site"
                isRequired
                name="ACDBArrivalDate"
                formik={formik}
              />
            </div>
          </div>
        </div>

        <div className="row my-3">
          <div className="col-4">
            <div className="mb-3">
              <FormikTextInput
                type="text"
                className="text-input"
                label="Transporter Name"
                placeholder="Enter Transporter Name"
                isRequired
                name="nameOfTransporter"
                formik={formik}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="mb-3">
              <FormikTextInput
                type="text"
                className="text-input"
                label="Consignee Name"
                placeholder="Enter Consignee Name"
                isRequired
                name="consigneeName"
                formik={formik}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="mb-3">
              <FormikTextInput
                type="text"
                className="text-input"
                label="Consignee Contact Number"
                placeholder="Enter Consignee Contact Number"
                isRequired
                name="consigneeContact"
                formik={formik}
              />
            </div>
          </div>
        </div>

        <div className="row my-3">
          <div className="col-12">
            <div className="mb-3">
              <div className="storage-item d-flex gap-2 align-items-center">
                <FormLabel htmlFor="storage" className="form-label">
                  Any Damaged / Missing Item?
                </FormLabel>

                <div className=" d-flex gap-3">
                  <YesNoToggle value={checked} onChange={handleChange} disabled={!canSave} />
                </div>
              </div>
            </div>
          </div>

          {checked === 'yes' && (
            <div className="col-6">
              <div className="mb-3">
                <FormikTextInput
                  type="text"
                  className="text-input"
                  label="List of Damaged / Missing Items"
                  name="missingItems"
                  placeholder="Enter List of Damaged / Missing Items"
                  formik={formik}
                />
              </div>
            </div>
          )}
        </div>

        <div className="buttons">
          <button
            type="button"
            className="prev-btn"
            onClick={() => {
              dispatch(changeStep(currentStep - 1));
            }}
          >
            Previous
          </button>

          {canSave ? ( // NEW
            <button type="submit" className="submit-btn">
              Next
            </button>
          ) : (
            <button
              type="button"
              onClick={() => {
                dispatch(changeStep(currentStep + 1));
              }}
              className="submit-btn"
            >
              Next
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

TransportDetails.propTypes = {
  currentStep: PropTypes.number,
};

export default TransportDetails;
